/**
 * Header Mega Nav — Hover interactions with delay
 * Matches B2C behavior: show after 150ms, hide after 300ms
 */
(function () {
  'use strict';

  var HOVER_DELAY_IN = 120;
  var HOVER_DELAY_OUT = 220;

  document.addEventListener('DOMContentLoaded', function () {
    var triggers = document.querySelectorAll('[data-megamenu-trigger]');

    // Shared timers so switching between menus is coordinated (no flicker).
    var showTimeout = null;
    var hideTimeout = null;

    function anyOpen() {
      for (var i = 0; i < triggers.length; i++) {
        if (triggers[i].classList.contains('is-active')) return true;
      }
      return false;
    }

    function syncMenuOpenState() {
      document.body.classList.toggle('mega-nav-open', anyOpen());
    }

    function activate(trigger) {
      triggers.forEach(function (other) {
        if (other !== trigger) other.classList.remove('is-active');
      });
      trigger.classList.add('is-active');
      syncMenuOpenState();
    }

    triggers.forEach(function (trigger) {
      function showMegamenu() {
        clearTimeout(hideTimeout);
        hideTimeout = null;
        clearTimeout(showTimeout);

        // If a mega menu is already open, switch instantly (feels seamless).
        if (anyOpen()) {
          activate(trigger);
          return;
        }

        showTimeout = setTimeout(function () {
          activate(trigger);
        }, HOVER_DELAY_IN);
      }

      function hideMegamenu() {
        clearTimeout(showTimeout);
        showTimeout = null;

        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(function () {
          trigger.classList.remove('is-active');
          syncMenuOpenState();
        }, HOVER_DELAY_OUT);
      }

      trigger.addEventListener('mouseenter', showMegamenu);
      trigger.addEventListener('mouseleave', hideMegamenu);

      // Keep megamenu open when hovering over it
      var megamenu = trigger.querySelector('.mega-nav__megamenu');
      if (megamenu) {
        megamenu.addEventListener('mouseenter', function () {
          clearTimeout(hideTimeout);
          hideTimeout = null;
        });
        megamenu.addEventListener('mouseleave', hideMegamenu);
      }
    });

    // Close all on click outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-megamenu-trigger]')) {
        triggers.forEach(function (trigger) {
          trigger.classList.remove('is-active');
        });
        syncMenuOpenState();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        triggers.forEach(function (trigger) {
          trigger.classList.remove('is-active');
        });
        syncMenuOpenState();
      }
    });
  });
})();
